import React, { useRef } from 'react';
var VeltNotificationsPanelHeader = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-header", { ref: ref }, children));
};
export default VeltNotificationsPanelHeader;
